import React, { useState } from 'react';

const COLOR_OPTIONS = [
    'from-red-500 to-orange-600',
    'from-emerald-500 to-teal-600',
    'from-sky-500 to-blue-600',
    'from-amber-500 to-orange-600',
    'from-pink-500 to-rose-600',
    'from-yellow-500 to-amber-600',
    'from-lime-500 to-green-600',
    'from-cyan-500 to-teal-600'
];

const CreateFolderModal = ({ onClose, onCreate, title = 'Create Folder' }) => {
    const [folderName, setFolderName] = useState('');
    const [selectedColor, setSelectedColor] = useState(COLOR_OPTIONS[0]);

    const handleSubmit = (e) => {
        e.preventDefault();
        const name = folderName.trim();
        if (!name) return;
        onCreate({ name, color: selectedColor });
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose}></div>
            <div className="relative w-full max-w-md mx-4 rounded-2xl bg-[var(--bg-surface)] border border-white/10 p-5 sm:p-6 shadow-2xl">
                <div className="flex items-start justify-between">
                    <div>
                        <h3 className="text-[22px] sm:text-[24px] tracking-tight font-semibold text-white">{title}</h3>
                        <p className="text-sm text-slate-400 mt-1">Add a name and color to get started.</p>
                    </div>
                    <button className="p-2 rounded-lg hover:bg-white/5" onClick={onClose} aria-label="Close">
                        <svg viewBox="0 0 24 24" width="20" height="20" className="text-slate-300" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="mt-5 space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-slate-300 mb-1">Folder name</label>
                        <input
                            type="text"
                            required
                            placeholder="e.g., Spanish Listening"
                            value={folderName}
                            onChange={(e) => setFolderName(e.target.value)}
                            className="w-full rounded-lg bg-slate-900/70 ring-1 ring-white/10 focus:ring-2 focus:ring-teal-500/40 outline-none px-3.5 py-2.5 text-sm placeholder:text-slate-500"
                        />
                    </div>

                    <div>
                        <span className="block text-sm font-medium text-slate-300 mb-1">Color</span>
                        <div className="grid grid-cols-8 gap-2">
                            {COLOR_OPTIONS.map((c) => (
                                <button
                                    key={c}
                                    type="button"
                                    onClick={() => setSelectedColor(c)}
                                    className={`h-8 rounded-md bg-gradient-to-br ${c} ring-2 ${selectedColor === c ? 'ring-white/80' : 'ring-transparent'}`}
                                    aria-selected={selectedColor === c}
                                />
                            ))}
                        </div>
                    </div>

                    <div className="flex items-center justify-end gap-2 pt-1">
                        <button type="button" className="rounded-lg px-3.5 py-2 text-sm font-medium bg-white/5 hover:bg-white/10 ring-1 ring-white/10" onClick={onClose}>Cancel</button>
                        <button type="submit" disabled={!folderName.trim()} className="inline-flex items-center gap-2 rounded-lg bg-gradient-to-r from-teal-600 to-emerald-600 px-4 py-2.5 text-sm font-medium text-white shadow-md shadow-teal-600/30 disabled:opacity-60">
                            <svg viewBox="0 0 24 24" width="18" height="18" className="text-white" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6L9 17l-5-5"/></svg>
                            Save
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreateFolderModal;


